import styled from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const RoleNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  & > span {
    padding: 0 16px;
  }
`;

export const ErrorMessage = styled.span`
  color: ${(props) => props.theme.colors.error || '#dc3545'};
  font-size: 12px;
  padding: 0 16px;
`;